import { Plus } from "lucide-react";

export function BrandLogo({ logoUrl, size = 36, className = "" }) {
  const s = Math.round(size * 1.15);
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt="Logo comitato"
        style={{ height: s, width: s }}
        className={`rounded-lg object-cover bg-white ${className}`}
      />
    );
  }
  return (
    <div
      style={{ height: s, width: s }}
      className={`rounded-lg bg-[#D32F2F] flex items-center justify-center ${className}`}
    >
      <Plus style={{ height: s * 0.62, width: s * 0.62 }} className="text-white" strokeWidth={3} />
    </div>
  );
}
